<template>
  <section class="section page__footer">
    <VPagination
      v-if="isVisible"
      :pages="pagination.pages"
      :currentPage="pagination.currentPage"
      @get-page="loadPage"
    />
  </section>
</template>

<script>
import VPagination from '@/components/page/VPagination'

export default {
  // Пагинация работает в связке с Vuex default по namespaced
  name: 'PaginationVuex',
  components: {
    VPagination
  },
  props: {
    namespaced: {
      type: String,
      required: true
    }
  },
  computed: {
    isVisible () {
      return this.$store.getters[this.namespaced + '/visibleTable']
    },
    pagination () {
      return this.$store.getters[this.namespaced + '/getPagination']
    }
  },
  methods: {
    async loadPage (pageNumber) {
      return this.$store.dispatch(this.namespaced + '/loadPage', pageNumber)
    }
  }
}
</script>
